import { LogTestCase } from "./logTestCase";
import { World } from "./testCase";
class LogPiRoot extends World {
    constructor(testCase) {
        super(testCase);
        this._logTestCase = testCase;
    }
    getPi() {
        return Math.PI;
    }
}
export class LogPiTestCase extends LogTestCase {
    //This is the "world" argument that users code against.
    createRoot() {
        return new LogPiRoot(this);
    }
    createElement(document) {
        let template = document.createElement("template");
        let html = `<div class="log_container">
      <div>
        <div>
          <button class="get_pi_button w-full btn-darkBackHigh">Get Pi</button>
        </div>
        <div>
          <input type="number" readonly="true" class="get_pi_value move_value w-full bg-darkBack text-darkFore outline-none">
        </div>
        <div>
          <input type="text" class="log_value w-full bg-darkBack text-darkFore outline-none">
        </div>
        <div>
          <button class="log_button w-full btn-darkBackHigh">Log</button>
        </div>
        <br/>
      </div>
    </div>`;
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        //Get Pi
        let piInput = template.content.firstElementChild
            .getElementsByClassName("get_pi_value")[0];
        template.content.firstElementChild
            .getElementsByClassName("get_pi_button")[0]
            .addEventListener("click", () => {
            //this.log("Get Pi " + Math.PI);
            piInput.value = Math.PI.toString();
            this.queueEvaluate();
        });
        //Log Button
        let logInput = template.content.firstElementChild
            .getElementsByClassName("log_value")[0];
        template.content.firstElementChild
            .getElementsByClassName("log_button")[0]
            .addEventListener("click", () => {
            let logText = logInput.value;
            logInput.value = "";
            this.queueLogAction(logText);
            this.queueEvaluate();
        });
        return template.content.firstElementChild;
    }
    get styleSheet() {
        return `.log_container {
      width: 100%;
      height: 100%;
      display: flex;
      direction: column;
      align-items: center;
      justify-content: center;
    }

    .log_value,.get_pi_value {
      border: 2px solid var(--color-base02);
    }`;
    }
}
